import { render, staticRenderFns } from "./ArrivalTime.vue?vue&type=template&id=38c1b37e&"
import script from "./ArrivalTime.vue?vue&type=script&lang=js&"
export * from "./ArrivalTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c1b37e')) {
      api.createRecord('38c1b37e', component.options)
    } else {
      api.reload('38c1b37e', component.options)
    }
    module.hot.accept("./ArrivalTime.vue?vue&type=template&id=38c1b37e&", function () {
      api.rerender('38c1b37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/transports/components/Typos/ArrivalTime.vue"
export default component.exports